import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dedac342"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  style: {"white-space":"pre-line"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBmaWxsPSIjYzVkYmZmIiBkPSJNMCAwaDUxMnY1MTJIMHoiLz48cGF0aCBkPSJNMjU2IDMwNGM2MS42IDAgMTEyLTUwLjQgMTEyLTExMlMzMTcuNiA4MCAyNTYgODBzLTExMiA1MC40LTExMiAxMTIgNTAuNCAxMTIgMTEyIDExMnptMCA0MGMtNzQuMiAwLTIyNCAzNy44LTIyNCAxMTJ2NTZoNDQ4di01NmMwLTc0LjItMTQ5LjgtMTEyLTIyNC0xMTJ6IiBmaWxsPSIjODJhZWZmIi8+PC9zdmc+" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBmaWxsPSIjYzVkYmZmIiBkPSJNMCAwaDUxMnY1MTJIMHoiLz48cGF0aCBkPSJNMjU2IDMwNGM2MS42IDAgMTEyLTUwLjQgMTEyLTExMlMzMTcuNiA4MCAyNTYgODBzLTExMiA1MC40LTExMiAxMTIgNTAuNCAxMTIgMTEyIDExMnptMCA0MGMtNzQuMiAwLTIyNCAzNy44LTIyNCAxMTJ2NTZoNDQ4di01NmMwLTc0LjItMTQ5LjgtMTEyLTIyNC0xMTJ6IiBmaWxsPSIjODJhZWZmIi8+PC9zdmc+" }, null, -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  style: {"white-space":"pre-line"}
}
const _hoisted_10 = {
  key: 0,
  class: "ion-text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_image_slides = _resolveComponent("image-slides")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString($setup.loading || $setup.loadingUser ? '...' : $setup.isPostAuthorBanned($setup.post) ? $setup.t('PostPage.blockedContent') : $setup.post.title), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, {
                    "default-href": $setup.parentPath ? $setup.parentPath : '/posts'
                  }, null, 8, ["default-href"])
                ]),
                _: 1
              }),
              (!$setup.canUpdatePost($setup.post))
                ? (_openBlock(), _createBlock(_component_ion_buttons, {
                    key: 0,
                    slot: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openPopover($setup.post, $event)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            ios: $setup.ellipsisHorizontal,
                            md: $setup.ellipsisVertical
                          }, null, 8, ["ios", "md"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_refresher, {
            slot: "fixed",
            onIonRefresh: _cache[1] || (_cache[1] = ($event: any) => ($setup.fetchLatestPost($setup.currPostId, $event)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_refresher_content)
            ]),
            _: 1
          }),
          ($setup.loading || $setup.loadingUser)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_ion_spinner)
              ]))
            : (_openBlock(), _createBlock(_component_ion_grid, {
                key: 1,
                fixed: ""
              }, {
                default: _withCtx(() => [
                  ($setup.post)
                    ? (_openBlock(), _createBlock(_component_ion_row, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, { size: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_row, null, {
                                    default: _withCtx(() => [
                                      (!$setup.isPostAuthorBanned($setup.post))
                                        ? (_openBlock(), _createBlock(_component_ion_col, {
                                            key: 0,
                                            class: "ion-text-center",
                                            "size-xs": "12",
                                            "size-md": "4",
                                            "size-xl": "3"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("img", {
                                                class: "post-image",
                                                src: $setup.post.image
                                              }, null, 8, _hoisted_2),
                                              ($setup.post.photoLinks.length > 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                                    _createVNode(_component_image_slides, {
                                                      imageLinks: $setup.post.photoLinks,
                                                      minSlidesPerView: 3,
                                                      size: "small",
                                                      hideEyeIcon: true,
                                                      defaultCaption: $setup.post.title
                                                    }, null, 8, ["imageLinks", "defaultCaption"])
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_ion_col, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_card_header, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_card_subtitle, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString($setup.formatDate($setup.post.createdAt)), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_card_content, null, {
                                            default: _withCtx(() => [
                                              ($setup.isPostAuthorBanned($setup.post))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString($setup.t('PostPage.blockedContent')), 1))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString($setup.post.content), 1)),
                                              _createVNode(_component_ion_item, {
                                                class: "ion-no-padding",
                                                lines: "none"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_badge, { slot: "start" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_icon, {
                                                        style: {"cursor":"pointer"},
                                                        icon: $setup.thumbsUpOutline,
                                                        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.likePost($setup.post)))
                                                      }, null, 8, ["icon"]),
                                                      _createTextVNode(" " + _toDisplayString($setup.post.likeCount) + " ", 1),
                                                      _createVNode(_component_ion_icon, {
                                                        style: {"cursor":"pointer"},
                                                        icon: $setup.thumbsDownOutline,
                                                        onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.dislikePost($setup.post)))
                                                      }, null, 8, ["icon"]),
                                                      _createTextVNode(" " + _toDisplayString($setup.post.dislikeCount), 1)
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createTextVNode(" " + _toDisplayString($setup.post.rating), 1)
                                                ]),
                                                _: 1
                                              }),
                                              _createElementVNode("small", null, _toDisplayString($setup.t('PostPage.lastUpdated')) + _toDisplayString($setup.formatDate($setup.post.updatedAt)), 1),
                                              _createVNode(_component_ion_item, {
                                                class: "ion-no-padding",
                                                lines: "none"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_chip, null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_avatar, null, {
                                                        default: _withCtx(() => [
                                                          _hoisted_6
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_ion_label, null, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString($setup.post.username || 'Unknown'), 1)
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  }),
                                                  ($setup.canUpdatePost($setup.post))
                                                    ? (_openBlock(), _createBlock(_component_ion_buttons, {
                                                        key: 0,
                                                        slot: "end"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_ion_button, {
                                                            onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.openEditPostModal($setup.post)))
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_ion_icon, {
                                                                slot: "icon-only",
                                                                icon: $setup.create
                                                              }, null, 8, ["icon"])
                                                            ]),
                                                            _: 1
                                                          }),
                                                          _createVNode(_component_ion_button, {
                                                            onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.deletePost($setup.post)))
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_ion_icon, {
                                                                slot: "icon-only",
                                                                icon: $setup.trash
                                                              }, null, 8, ["icon"])
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      }))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, { size: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_card_header, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_card_title, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString($setup.postComments.length) + _toDisplayString($setup.t('PostPage.numOfComments')), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  ($setup.userLoggedIn)
                                    ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_textarea, {
                                            modelValue: $setup.newCommentContent,
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.newCommentContent) = $event)),
                                            placeholder: `${$setup.t('PostPage.newComment')}...`
                                          }, null, 8, ["modelValue", "placeholder"])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  ($setup.userLoggedIn)
                                    ? (_openBlock(), _createBlock(_component_ion_item, {
                                        key: 1,
                                        lines: "none"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_buttons, { slot: "end" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_button, {
                                                size: "small",
                                                color: "primary",
                                                onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.addNewPostComment($setup.post)))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString($setup.t('PostPage.commentBtnText')), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_ion_row, null, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.postComments, (comment, index) => {
                                        return (_openBlock(), _createBlock(_component_ion_col, {
                                          size: "12",
                                          class: "ion-no-padding",
                                          key: comment.id
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_card, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_card_header, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_card_subtitle, null, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(" #" + _toDisplayString(index+1) + " ", 1),
                                                        _createVNode(_component_ion_chip, null, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_ion_avatar, null, {
                                                              default: _withCtx(() => [
                                                                _hoisted_7
                                                              ]),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_ion_label, null, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(comment.username), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_ion_card_content, null, {
                                                  default: _withCtx(() => [
                                                    ($setup.isPostAuthorBanned(comment))
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString($setup.t('PostPage.blockedContent')), 1))
                                                      : (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(comment.content), 1)),
                                                    _createVNode(_component_ion_item, {
                                                      class: "ion-no-padding",
                                                      lines: "full"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_ion_badge, {
                                                          color: "light",
                                                          slot: "start"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_ion_icon, {
                                                              style: {"cursor":"pointer"},
                                                              icon: $setup.thumbsUpOutline,
                                                              onClick: ($event: any) => ($setup.likePostComment(comment))
                                                            }, null, 8, ["icon", "onClick"]),
                                                            _createTextVNode(" " + _toDisplayString(comment.likeCount) + " ", 1),
                                                            _createVNode(_component_ion_icon, {
                                                              style: {"cursor":"pointer"},
                                                              icon: $setup.thumbsDownOutline,
                                                              onClick: ($event: any) => ($setup.dislikePostComment(comment))
                                                            }, null, 8, ["icon", "onClick"]),
                                                            _createTextVNode(" " + _toDisplayString(comment.dislikeCount), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_ion_item, {
                                                      class: "ion-no-padding",
                                                      lines: "none"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_ion_label, null, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("p", null, [
                                                              _createElementVNode("small", null, _toDisplayString($setup.formatDate(comment.createdAt)), 1)
                                                            ])
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        (!$setup.canUpdatePost(comment))
                                                          ? (_openBlock(), _createBlock(_component_ion_buttons, {
                                                              key: 0,
                                                              slot: "end"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_ion_button, {
                                                                  onClick: ($event: any) => ($setup.openPopover(comment, $event, true))
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_ion_icon, {
                                                                      slot: "icon-only",
                                                                      ios: $setup.ellipsisHorizontal,
                                                                      md: $setup.ellipsisVertical
                                                                    }, null, 8, ["ios", "md"])
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["onClick"])
                                                              ]),
                                                              _: 2
                                                            }, 1024))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128)),
                                      _createVNode(_component_ion_col, { size: "12" }, {
                                        default: _withCtx(() => [
                                          ($setup.loadingPostComments)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                                _createVNode(_component_ion_spinner)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}